import { useData } from "./DataContext.js";

import { Transition } from "react-transition-group";

import Badge from "react-bootstrap/Badge";

import MoneyFormat from "./MoneyFormat.js";

import { BsFillFileEarmarkTextFill, BsFillChatTextFill, BsXCircleFill, BsCheckCircleFill } from "react-icons/bs";
import { TbHelpSquareFilled, TbSquareChevronLeftFilled, TbSquareChevronRightFilled } from "react-icons/tb";


export default function DocumentTitle (props)
{
    const gData = useData();

    const document = gData.state.documents[props.documentId];
    const documentContent = gData.content.documents[props.documentId];

    let documentTitle = (<span className="opacity-25">Document inconnu</span>);
    if (document.found)
    {
	if (documentContent.type === "document")
	{
	    documentTitle = (<span>{documentContent.title}</span>);
	}
	
	else if (documentContent.type === "advice")
	{
	    const char = gData.content.chars[documentContent.charId];
	    documentTitle = (<span>Avis {char.shortTitle}</span>);
	}
    }

    const result = gData.state.reports[documentContent.solutionId].result;
    const disabled = result !== null;
    const check = props.value !== "collection" && ((documentContent.variableId === null && props.value === "investment") || (documentContent.variableId !== null && documentContent.variableId === props.variableId && documentContent.value === props.value));

    let color = "secondary";
    if (disabled && !check) color = "secondary";
    else {
	    switch (props.value)
	    {
		case "pos" :        color = "success";   break;
		case "neg" :        color = "danger";    break;
		case "collection" : color = "secondary"; break;
		case "investment" : color = "dark";   break;
		default :
	    }
	}

    /* const iconColor = "text-dark ";
     * const impactColor = "text-"+color+" ";
     * const borderColor = "border-"+color+" ";
     * const bgColor = "white ";
     * const titleColor = "text-dark ";
     */

    const iconColor = "text-white ";
    const impactColor = "text-white ";
    const borderColor = "border-0 ";
    const bgColor = color+" ";
    const titleColor = "text-white ";

    const size = props.size === undefined ? "sm" : props.size;
    const iconSize = size === "sm" ? "fs-5 " : "fs-5 ";
    const titleSize = size === "sm" ? "fs-6 fw-normal " : "fs-5 fw-normal ";
    /* const gap = size === "sm" ? "gap-2 " : "gap-2 "; */

    let documentIcon = (<></>);
    
    if (disabled && check) documentIcon = (<BsCheckCircleFill className={iconSize + iconColor}/>);
    else if (disabled && !check) documentIcon = (<BsXCircleFill className={iconSize + iconColor}/>);
    else if (documentContent.variableId === null) documentIcon = (<BsFillFileEarmarkTextFill className={iconSize + iconColor}/>);
    else if (documentContent.variableId !== null && documentContent.type === "document") documentIcon = (<BsFillFileEarmarkTextFill className={iconSize + iconColor}/>);
    else if (documentContent.variableId !== null && documentContent.type === "advice")  documentIcon = (<BsFillChatTextFill className={iconSize + iconColor}/>);

    
    let impactIcons = (<></>);
    if (documentContent.variableId === null)
    {
	if (props.value === "investment") impactIcons = (<span className={"fs-6 me-1 " + impactColor}><MoneyFormat value={-documentContent.cost} noIcon={true}/></span>);
	//else impactIcons = (<TbCoinEuroFilled className={"fs-4 " + impactColor}/>);
	else impactIcons = (<span className={"fs-4 me-2 " + impactColor}>€</span>);
    }
    else {
	const impact = Math.abs(documentContent.impact);
	if (disabled && !check) impactIcons = Array.from(Array(impact).keys()).map((index) => (<TbHelpSquareFilled key={index} className={"fs-4 " + impactColor}/>));
	else if (props.value === "pos") impactIcons = Array.from(Array(impact).keys()).map((index) => (<TbSquareChevronRightFilled key={index} className={"fs-4 " + impactColor}/>));
	else if (props.value === "neg") impactIcons = Array.from(Array(impact).keys()).map((index) => (<TbSquareChevronLeftFilled key={index} className={"fs-4 " + impactColor}/>));
	else impactIcons = Array.from(Array(impact).keys()).map((index) => (<TbHelpSquareFilled key={index} className={"fs-4 " + impactColor}/>));
	/* if (props.value === "pos") impactIcons = Array.from(Array(impact).keys()).map((index) => (<BsFillPlusSquareFill key={index} className={"fs-5 " + impactColor}/>));
	   else if (props.value === "neg") impactIcons = Array.from(Array(impact).keys()).map((index) => (<BsFillDashSquareFill key={index} className={"fs-5 " + impactColor}/>));
	   else impactIcons = Array.from(Array(impact).keys()).map((index) => (<BsFillQuestionSquareFill key={index} className={"fs-5 " + impactColor}/>)); */
    }
    
    
    const width = gData.content.params.documentWidth || "auto";
    const height = gData.content.params.documentHeight || "auto";
    
    return (
	<Badge bg={bgColor} text="dark" className={"user-select-none border border-2 shadow " + borderColor} style={{ width, height }}>
	    <div className="h-100 d-flex align-items-center gap-2">
		<Transition timeout={500} in={result}>
		    {(state) => (<div className={"d-inline-flex pop-in-"+state}>{documentIcon}</div>)}
		</Transition>
		<div className={"d-inline-block text-truncate " + titleColor + titleSize}>{documentTitle}</div>
		<div className="flex-grow-1 text-end">{impactIcons}</div>  {/* style={{ gap: "3px" }} */}
	    </div>
	</Badge>
    );
}


